import { useEffect } from "react"

interface IConfig {
  title?: string
  prefix?: string
}

const defaultConfig: IConfig = {
  prefix: "T4Ever Legacy AI",
  title: "T4Ever Legacy AI",
}

const useHead = (config: IConfig) => {
  const { title, prefix } = { ...defaultConfig, ...config }

  useEffect(() => {
    if (title) {
      document.title = `${title} - ${prefix}`
    }
  }, [title, prefix])
}

export default useHead
